<ng-template let-context let-modal="modal" #modalTemplate class="refresh-popup">
    <div class="content">
        <h2>{{popupTitle}}</h2>
        <div class="ui input">
            <input type="text" placeholder="Entrer la valeure" [(ngModel)]="value">
        </div>
    </div>
    <div class="actions">
        <button class="ui button" (click)="modal.approve()">Valider</button>
    </div>
</ng-template>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/generic/popup/stringPopup/stringPopup.html